export const NEWS_LIST = 'news_list'
export const NEWS_DETAIL = 'news_detail'